import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { MercuryService } from '../service/mercury.service';
import { ThemeService } from '../service/theme.service';
import { ResolverErrorService } from './resolver-error.service';

@Injectable({ providedIn: 'root' })
export class GiftcardResolver implements Resolve<any> {
  constructor(
    private mercuryService: MercuryService,
    private themeService: ThemeService,
    private resolverError: ResolverErrorService
  ) {}

  async resolve(route: ActivatedRouteSnapshot): Promise<any> {
    const preview = route.queryParamMap.get('preview') as string;
    return await this.mercuryService
      .getProductByHandle('gift-card', Boolean(preview))
      .toPromise()
      .then((result: any) => {
        if (!result) {
          return this.resolverError.showNotFound();
        }
        this.themeService.viewProduct(result);
        return {
          ...result,
          seo: {
            title: result?.metafields?.global?.title_tag || result?.title,
            description:
              result?.metafields?.global?.description_tag ||
              result?.body_html,
          },
        };
      })
      .catch((err) => this.resolverError.handle(err));
  }
}
